import Transformer from './transformer';
import dateUtil from '../utils/dateTime';
// import timeSlotUtil from '../utils/timeSlot';
import moment from 'moment-timezone';

export default class CorporateTransformer extends Transformer {
  static fetch(corporate) {
    const remaining_session = (corporate) => {
      if (corporate.package_type == 'free' || corporate.package_type == 'donation') {
        return '∞';
      } else if (corporate.package_type == 'time') {
        return `${Math.floor(corporate.wallet_time / 30)} / ${Math.ceil(corporate.max_wallet_time / 30)}`;
      } else {
        return '-';
      }
    };

    const returnValue = {
      id: corporate.id,
      name: corporate.name,
      max_session: corporate.max_session,
      session: corporate.session,
      parent_organization: corporate.parent_organization ? corporate.parent_organization.data.id : null,
      active: corporate.active,
      privilege_inheritance_policy: corporate.privilege_inheritance_policy,
      category1_title: corporate.category1_title,
      category2_title: corporate.category2_title,
      category3_title: corporate.category3_title,
      category4_title: corporate.category4_title,
      choice1: corporate.choice1 ? corporate.choice1.data : '',
      choice2: corporate.choice2 ? corporate.choice2.data : '',
      choice3: corporate.choice3 ? corporate.choice3.data : '',
      choice4: corporate.choice4 ? corporate.choice4.data : '',
      user_cap: corporate.user_cap,
      stress_test_limit: corporate.stress_test_limit,
      color: corporate.color,
      description: corporate.description,
      expire: corporate.expire ? dateUtil.formateDateTimeForDisplay(corporate.expire, 'YYYY-MM-DD') : null,
      expire_time: corporate.expire ? dateUtil.formateDateTimeForDisplay(corporate.expire, 'HH:mm') : null,
      images: corporate.images ? corporate.images : { banner: '' },
      max_wallet_time: corporate.max_wallet_time,
      package: corporate.package,
      package_start: corporate.package_start
        ? dateUtil.formateDateTimeForDisplay(corporate.package_start, 'YYYY-MM-DD')
        : null,
      package_start_time: corporate.package_start
        ? dateUtil.formateDateTimeForDisplay(corporate.package_start, 'HH:mm')
        : null,
      package_type: corporate.package_type,
      quota_per_head: corporate.quota_per_head,
      wallet_time: corporate.wallet_time,
      created_at: corporate.created_at,
      tag_ids: corporate.tag_ids ? corporate.tag_ids : [],
      remaining_session: remaining_session(corporate),
      refresh_quota: corporate.refresh_quota,
      contracts: corporate.contracts,
      transactions: corporate.transactions,
      sale_responsible_admin_id: corporate.sale_responsible_admin_id,
    };

    if (corporate.tags && corporate.tags.length) {
      returnValue.tags = corporate.tags;
    }

    if (corporate.parent_corporate) {
      returnValue.parent_corporate = this.fetch(corporate.parent_corporate.data);
    }

    return returnValue;
  }

  static send(corporate) {
    // let eligible_provider_types;
    // if (corporate.eligible_provider_types) {
    //   eligible_provider_types = [];
    //   eligible_provider_types.push(corporate.eligible_provider_types);
    // } else {
    //   eligible_provider_types = null;
    // }
    const returnValue = {
      name: corporate.name,
      description: corporate.description,
      address: corporate.address,
      expire: moment(`${corporate.expire} ${corporate.expire_time}`).format('Y-MM-DD HH:mm:ss'),
      package_start: moment(`${corporate.package_start} ${corporate.package_start_time}`).format('Y-MM-DD HH:mm:ss'),
      parent_organization_id: corporate.parent_organization_id,
      package: corporate.package,
      package_type: corporate.package_type == 'unlimited' ? 'free' : corporate.package_type,
      category1_title: corporate.category1_title,
      category2_title: corporate.category2_title,
      category3_title: corporate.category3_title,
      category4_title: corporate.category4_title,
      // User inputs quota in sessions; backend stores minutes. Convert at the boundary.
      // 1 session = 30 minutes. Null means unlimited.
      quota_per_head: corporate.quota_per_head ? Number(corporate.quota_per_head) * 30 : null,
      user_cap: corporate.user_cap,
      color: corporate.color,
      // max_wallet_time: corporate.max_wallet_time,
      // eligible_provider_types : corporate.eligible_provider_types,
      stress_test_limit: corporate.stress_test_limit,
      tag_ids: corporate.tag_ids,
      refresh_quota: corporate.refresh_quota,
      timezone: 7,
      sale_responsible_admin_id: corporate.sale_responsible_admin_id,
    };
    if (corporate.banner) {
      returnValue.banner = corporate.banner;
    }
    if (corporate.active !== null) {
      returnValue.active = corporate.active;
    }
    if (corporate.admin_id) {
      returnValue.admin_id = corporate.admin_id;
    }

    return returnValue;
  }

  static sendCreate(corporate) {
    const returnValue = {
      name: corporate.name,
      description: corporate.description,
      address: corporate.address,
      expire: dateUtil.formatDateTimeForPayload(corporate.expire, corporate.expire_time),
      package_start: dateUtil.formatDateTimeForPayload(corporate.package_start, corporate.package_start_time),
      parent_organization_id: corporate.parent_organization_id,
      package: corporate.package,
      package_type: corporate.package_type == 'unlimited' ? 'free' : corporate.package_type,
      category1_title: corporate.category1_title,
      category2_title: corporate.category2_title,
      category3_title: corporate.category3_title,
      category4_title: corporate.category4_title,
      // User inputs quota in sessions; backend stores minutes. Convert at the boundary.
      // 1 session = 30 minutes. Null means unlimited.
      quota_per_head: corporate.quota_per_head ? Number(corporate.quota_per_head) * 30 : null,
      user_cap: corporate.user_cap,
      color: corporate.color,
      max_session: corporate.max_session,
      session: corporate.session,
      max_wallet_time: corporate.package_type == 'unlimited' ? null : corporate.max_wallet_time,
      wallet_time: corporate.wallet_time,
      // eligible_provider_types : corporate.eligible_provider_types,
      stress_test_limit: corporate.stress_test_limit,
      tag_ids: corporate.tag_ids,
      refresh_quota: corporate.refresh_quota,
      package_size: corporate.package_size,
      package_tier: corporate.package_tier,
      internal_note: corporate.internal_note,
      actual_start_at: dateUtil.formatDateTimeForPayload(corporate.actual_start_at, corporate.actual_start_at_time),
      actual_end_at: dateUtil.formatDateTimeForPayload(corporate.actual_end_at, corporate.actual_end_at_time),
      timezone: 7,
      sale_responsible_admin_id: corporate.sale_responsible_admin_id,
    };
    if (corporate.banner) {
      returnValue.banner = corporate.banner;
    }
    if (corporate.active !== null) {
      returnValue.active = corporate.active;
    }
    if (corporate.admin_id) {
      returnValue.admin_id = corporate.admin_id;
    }

    return returnValue;
  }

  // Builds the activate/deactivate payload. Package name is deliberately left out:
  // this page holds a cached copy, so resending it could overwrite a newer name.
  static sendToggle(profile) {
    // The request body sent when activating or deactivating this organisation
    const togglePayload = {
      name: profile.name,
      description: profile.description,
      active: profile.active,
      package_type: profile.package_type,
    };
    return togglePayload;
  }

  static fetchForTable(corporate) {
    return {
      id: corporate.id,
      name: corporate.name,
      description: corporate.description,
      package_type: corporate.package_type,
      package_start: CorporateTransformer.package_start(corporate),
      expire: CorporateTransformer.expire(corporate),
      created: dateUtil.formatDateTimeFromTimeStamp(corporate.created),
    };
  }

  static expire(corporate) {
    if (corporate.expire) return dateUtil.formatDateTimeFromTimeStamp(corporate.expire);
    else return 'No Expire';
  }
  static package_start(corporate) {
    if (corporate.package_start) return dateUtil.formatDateTimeFromTimeStamp(corporate.package_start);
    else return '-';
  }

  static transformCategoryChoice(categoryChoices) {
    const categoryData = {};
    categoryChoices.forEach((item) => {
      if (!categoryData[`${item.category}`]) {
        categoryData[`${item.category}`] = [];
        categoryData[`${item.category}`].push(item);
      } else {
        categoryData[`${item.category}`].push(item);
      }
    });
    return categoryData;
  }
}
